import { Injectable } from '@angular/core';
import { PlanningText } from '../../classes/planningtext.class';
import { ApiService } from '../api/api.service';
import { RealtimeType } from '../realtime/realtime-type.enum';
import { RealtimeService } from '../realtime/realtime.service';
import { WebsocketService } from '../websocket/websocket.service';

@Injectable({ providedIn: 'root' })
export class PlanningTextService extends RealtimeService<PlanningText> {
    constructor(
        private apiService: ApiService,
        protected websocketService: WebsocketService
    ) {
        super(websocketService, RealtimeType.planningText);
    }

    public itemInDaterange() {
        return true;
    }

    public saveText(id: number, text: string) {
        return this.apiService.postCall('planning/planningtext', { text, id });
    }
}
